var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalPostLux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15622_161551)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 67C56.7023 67 67 56.7023 67 44C67 31.2977 56.7023 21 44 21C31.2977 21 21 31.2977 21 44C21 56.7023 31.2977 67 44 67Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2955 47.3862C59.2985 45.1673 58.7018 42.9888 57.5687 41.0811C58.0706 37.4926 57.129 34.2095 54.6846 32.3018C53.73 31.5616 52.6079 31.0677 51.4173 30.8637C49.4587 28.8135 47.0171 27.6265 44.3865 27.6639C42.5652 27.7147 40.8042 28.3273 39.3445 29.4178C37.1761 29.391 35.0532 30.0408 33.2712 31.2767C27.5081 35.3536 27.1523 44.7962 32.491 52.3502C37.8306 59.9045 46.5016 62.2275 52.7743 58.7392C53.8496 58.1413 54.7784 57.3117 55.4937 56.3107C56.6932 55.1538 57.6479 53.7675 58.301 52.2343C58.9541 50.7011 59.2923 49.0527 59.2955 47.3862Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.4098 37.6111C58.7539 45.1844 59.0592 55.2557 52.7893 58.7441C46.5188 62.2324 37.8348 59.9288 32.4924 52.3501C27.1506 44.7713 27.5091 35.3526 33.2722 31.2712C39.0348 27.189 48.0567 30.0378 53.4098 37.6111Z",
    fill: "url(#paint0_linear_15622_161551)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9813 42.8025C56.1323 51.2764 51.1896 58.2377 44.9413 58.3509C38.6925 58.4641 33.5017 51.6841 33.3398 43.2102C33.1779 34.7358 38.1396 27.7749 44.3879 27.6644C50.6362 27.5539 55.8383 34.3281 55.9813 42.8025Z",
    fill: "url(#paint1_linear_15622_161551)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9298 49.3179C49.2085 55.3557 41.9022 57.5276 37.6043 54.1741C33.3069 50.8206 33.6443 43.1986 38.3602 37.1609C43.0761 31.1227 50.3878 28.9485 54.6857 32.3047C58.9835 35.6609 58.6462 43.2798 53.9303 49.3179H53.9298Z",
    fill: "url(#paint2_linear_15622_161551)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2961 47.3859C59.2962 49.8341 58.5703 52.2273 57.2103 54.2629C55.8503 56.2986 53.9172 57.8852 51.6555 58.8223C49.3937 59.7593 46.9049 60.0046 44.5038 59.5272C42.1026 59.0498 39.8969 57.8712 38.1656 56.1402C36.4343 54.4093 35.2551 52.2039 34.7772 49.8028C34.2993 47.4018 34.5441 44.9129 35.4806 42.651C36.4172 40.389 38.0034 38.4556 40.0388 37.0951C42.0741 35.7347 44.4672 35.0083 46.9153 35.0078C48.5421 35.0039 50.1536 35.3214 51.6572 35.942C53.1609 36.5627 54.5272 37.4742 55.6776 38.6244C56.828 39.7745 57.7399 41.1406 58.3609 42.6442C58.9818 44.1477 59.2997 45.7592 59.2961 47.3859Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5898 43.4061C38.7139 43.3872 38.9082 43.3655 39.1671 43.3362C39.4936 43.301 39.821 43.2861 40.1493 43.2902C40.4452 43.2902 40.7401 43.3173 41.0315 43.3714C41.3187 43.4218 41.5935 43.527 41.841 43.6812C42.0881 43.8381 42.2892 44.0578 42.4236 44.318C42.5851 44.654 42.6613 45.0247 42.6446 45.3972C42.6557 45.7291 42.5951 46.0595 42.4669 46.3659C42.3636 46.6066 42.2034 46.8186 42.0002 46.9837C41.8026 47.1371 41.5758 47.2489 41.3336 47.3129C41.0824 47.3777 40.8241 47.4103 40.5647 47.4099H40.2463C40.1711 47.4056 40.0963 47.3956 40.0226 47.3801V49.2959C39.8783 49.323 39.7493 49.3415 39.6339 49.3523C39.5211 49.3523 39.4129 49.3685 39.3155 49.3685C39.0755 49.3653 38.8363 49.341 38.6007 49.2959L38.5898 43.4061ZM40.0118 46.1823C40.0557 46.1991 40.1024 46.2074 40.1493 46.2067C40.2183 46.2108 40.2878 46.2108 40.3568 46.2067C40.4665 46.215 40.5767 46.1989 40.6794 46.1595C40.7822 46.1202 40.875 46.0586 40.9511 45.9791C41.0272 45.8996 41.0847 45.8043 41.1196 45.6999C41.1545 45.5956 41.1658 45.4848 41.1528 45.3755C41.1569 45.234 41.134 45.093 41.0851 44.9602C41.042 44.8566 40.9756 44.7644 40.8912 44.6905C40.8069 44.6218 40.7083 44.573 40.6026 44.5475C40.4887 44.5265 40.3727 44.5192 40.2571 44.5259H40.1439C40.0999 44.5232 40.0558 44.5232 40.0118 44.5259V46.1823Z",
    fill: "url(#paint3_linear_15622_161551)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9143 47.1942C42.9107 46.883 42.9572 46.5733 43.0518 46.2769C43.1337 46.0145 43.2707 45.7727 43.4536 45.5675C43.6363 45.3668 43.8622 45.2108 44.1148 45.1116C44.4052 44.9985 44.715 44.9434 45.0266 44.9492C45.3418 44.9429 45.6552 44.998 45.9494 45.1116C46.2019 45.2108 46.4278 45.3668 46.6105 45.5671C46.7931 45.7727 46.9307 46.0144 47.0123 46.2769C47.1062 46.5735 47.1518 46.8832 47.1476 47.1942C47.1519 47.4999 47.1062 47.8043 47.0123 48.0953C46.9302 48.3545 46.7932 48.5929 46.6105 48.7943C46.4268 48.9916 46.2007 49.1447 45.9494 49.2421C45.6545 49.3522 45.3413 49.4053 45.0266 49.3986C44.7155 49.4049 44.406 49.3518 44.1148 49.2421C43.8634 49.1447 43.6373 48.9916 43.4536 48.7943C43.2709 48.5929 43.1339 48.3545 43.0518 48.0953C42.9571 47.8044 42.9107 47.5 42.9143 47.1942ZM45.7442 47.1942C45.762 46.913 45.7003 46.6324 45.566 46.3847C45.5082 46.2958 45.4277 46.224 45.3329 46.1766C45.2381 46.1292 45.1324 46.1079 45.0266 46.115C44.9207 46.1073 44.8147 46.1283 44.7197 46.1758C44.6247 46.2232 44.5443 46.2954 44.4868 46.3847C44.373 46.6365 44.3141 46.9097 44.3141 47.1861C44.3141 47.4625 44.373 47.7356 44.4868 47.9875C44.5441 48.077 44.6245 48.1493 44.7195 48.1968C44.8146 48.2442 44.9207 48.2651 45.0266 48.2572C45.1324 48.2645 45.2383 48.2434 45.3331 48.1959C45.428 48.1485 45.5084 48.0765 45.566 47.9875C45.6977 47.7446 45.7594 47.47 45.7442 47.1942Z",
    fill: "url(#paint4_linear_15622_161551)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9032 46.6359C50.0566 46.6751 50.2067 46.7288 50.351 46.7951C50.4796 46.8551 50.5964 46.9371 50.6965 47.0377C50.7962 47.1414 50.8733 47.2645 50.9229 47.3994C50.9829 47.5654 51.0113 47.7408 51.0068 47.9176C51.0077 48.1196 50.9635 48.3198 50.8769 48.5029C50.7907 48.6868 50.6612 48.847 50.4994 48.9697C50.3153 49.1109 50.1068 49.217 49.8843 49.2827C49.6103 49.3645 49.3254 49.4036 49.0396 49.3986C48.7949 49.3999 48.5505 49.3809 48.309 49.3418C48.0651 49.2967 47.8258 49.23 47.5938 49.1424C47.6266 48.7494 47.7299 48.3656 47.8986 48.0091C48.2515 48.1709 48.6352 48.2546 49.0234 48.2544H49.2286C49.2935 48.2508 49.358 48.2391 49.4202 48.2193C49.4698 48.2017 49.5149 48.1751 49.5551 48.1413C49.5722 48.1239 49.5856 48.1033 49.5945 48.0805C49.6033 48.0578 49.6074 48.0335 49.6065 48.0091C49.6071 47.9747 49.5974 47.9408 49.5786 47.912C49.5597 47.8831 49.5327 47.8606 49.5009 47.8472C49.4221 47.8085 49.34 47.7769 49.2556 47.7525L48.6973 47.5965C48.4221 47.5247 48.1713 47.3801 47.9712 47.178C47.8722 47.0689 47.7959 46.9411 47.7468 46.8022C47.6977 46.6633 47.6768 46.516 47.6853 46.3689C47.6826 46.1669 47.7272 45.9675 47.8147 45.7858C47.9049 45.6099 48.0335 45.4566 48.1899 45.3353C48.3599 45.2119 48.551 45.1205 48.7537 45.0656C48.9878 44.9975 49.2306 44.964 49.4743 44.9659C49.7034 44.9677 49.9317 44.9904 50.1567 45.0335C50.4047 45.0764 50.6496 45.1395 50.8877 45.2221C50.8742 45.4133 50.8386 45.6027 50.7826 45.7858C50.7285 45.9711 50.6591 46.152 50.5752 46.3256C50.3996 46.2572 50.2192 46.2022 50.0354 46.161C49.8473 46.1148 49.6545 46.0903 49.4608 46.0879C49.1907 46.0879 49.0748 46.1583 49.0748 46.3013C49.0745 46.3307 49.0828 46.3596 49.0986 46.3844C49.1143 46.4093 49.1369 46.4291 49.1636 46.4415C49.229 46.4758 49.2976 46.5028 49.3688 46.5227L49.9032 46.6359Z",
    fill: "url(#paint5_linear_15622_161551)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6029 46.2072H51.3862C51.3599 46.1063 51.3418 46.0034 51.332 45.8996V45.6295V45.3598C51.3424 45.2579 51.3604 45.1568 51.3862 45.0576H55.2064C55.2321 45.1568 55.2501 45.2579 55.2605 45.3598C55.2605 45.4545 55.2741 45.546 55.2741 45.6299C55.2741 45.7133 55.2741 45.8103 55.2605 45.8996C55.2506 46.0033 55.2326 46.1061 55.2064 46.2072H53.9924V49.291C53.8494 49.3122 53.7227 49.3284 53.6041 49.3419C53.5002 49.3535 53.3956 49.3589 53.2911 49.3582C53.1964 49.3582 53.0967 49.3582 52.9808 49.3419C52.8645 49.3257 52.7404 49.3122 52.6029 49.291V46.2072Z",
    fill: "url(#paint6_linear_15622_161551)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5977 50.6284H38.8673V51.8425H39.4879V52.0801H38.5977V50.6284Z",
    fill: "url(#paint7_linear_15622_161551)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8516 50.6297H40.1212V51.5411C40.1184 51.5826 40.1248 51.6241 40.1399 51.6629C40.155 51.7016 40.1785 51.7365 40.2086 51.7651C40.2388 51.7937 40.2749 51.8153 40.3143 51.8284C40.3538 51.8414 40.3957 51.8456 40.4369 51.8405C40.4778 51.8441 40.5189 51.8389 40.5576 51.8253C40.5963 51.8117 40.6316 51.79 40.6612 51.7617C40.6909 51.7333 40.7141 51.699 40.7294 51.661C40.7447 51.6229 40.7517 51.5821 40.7499 51.5411V50.6211H41.0196V51.5411C41.0104 51.6884 40.9454 51.8266 40.8379 51.9276C40.7303 52.0287 40.5883 52.0849 40.4408 52.0849C40.2932 52.0849 40.1512 52.0287 40.0437 51.9276C39.9361 51.8266 39.8711 51.6884 39.8619 51.5411L39.8516 50.6297Z",
    fill: "url(#paint8_linear_15622_161551)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8514 51.3383L41.422 50.6284H41.7215L41.9159 50.982C41.9619 51.0654 42.0079 51.1574 42.0079 51.1574C42.0331 51.0974 42.062 51.0388 42.094 50.9815L42.2938 50.6284H42.5932L42.1589 51.3383L42.6176 52.0801H42.3208L42.0994 51.6914C42.0507 51.6102 42.0106 51.5214 42.0106 51.5214C42.0106 51.5214 41.97 51.6107 41.9213 51.6914L41.6976 52.0801H41.4062L41.8514 51.3383Z",
    fill: "url(#paint9_linear_15622_161551)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0352 50.6284H43.8961V50.8553H43.2972V51.23H43.7797V51.4542H43.2972V51.8425H43.9285V52.0801H43.0356L43.0352 50.6284Z",
    fill: "url(#paint10_linear_15622_161551)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4733 50.6284H44.743L45.0127 51.341C45.0452 51.4244 45.0831 51.5511 45.0831 51.5511C45.0831 51.5511 45.1209 51.4249 45.153 51.341L45.4231 50.6284H45.6928L45.8574 52.0801H45.5872L45.5255 51.2706V51.0496C45.5255 51.0496 45.4822 51.1872 45.4497 51.2706L45.2206 51.8104H44.9933L44.7615 51.2706C44.7263 51.1872 44.683 51.0469 44.683 51.0469V51.2706L44.6212 52.0801H44.3516L44.4733 50.6284Z",
    fill: "url(#paint11_linear_15622_161551)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.375 50.6284H46.8905C47.1602 50.6284 47.3329 50.7637 47.3329 51.0009C47.3348 51.0627 47.3197 51.1238 47.2892 51.1775C47.2587 51.2313 47.2141 51.2757 47.1602 51.3058C47.2308 51.3284 47.2919 51.3737 47.3339 51.4348C47.376 51.4958 47.3965 51.5691 47.3924 51.6431C47.3924 51.9318 47.1602 52.0612 46.8959 52.0612H46.375V50.6284ZM46.8905 51.2165C46.9146 51.2177 46.9387 51.2138 46.9612 51.205C46.9838 51.1961 47.0041 51.1826 47.021 51.1653C47.0378 51.1479 47.0508 51.1272 47.059 51.1045C47.0672 51.0817 47.0705 51.0575 47.0686 51.0334C47.0703 51.0091 47.0667 50.9847 47.058 50.962C47.0493 50.9392 47.0357 50.9186 47.0182 50.9017C47.0007 50.8847 46.9798 50.8718 46.9568 50.8638C46.9338 50.8557 46.9093 50.8528 46.8851 50.8553H46.637V51.2165H46.8905ZM46.9175 51.8425C46.9726 51.8425 47.0254 51.8206 47.0644 51.7816C47.1033 51.7427 47.1252 51.6899 47.1252 51.6348C47.1252 51.5797 47.1033 51.5269 47.0644 51.4879C47.0254 51.449 46.9726 51.4271 46.9175 51.4271H46.6478V51.8425H46.9175Z",
    fill: "url(#paint12_linear_15622_161551)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5193 50.6047C48.6165 50.6028 48.7132 50.6204 48.8036 50.6566C48.8939 50.6927 48.9761 50.7466 49.0453 50.8151C49.1144 50.8835 49.1692 50.9651 49.2062 51.0551C49.2433 51.1451 49.262 51.2416 49.2611 51.3389C49.2611 51.5356 49.183 51.7243 49.0438 51.8634C48.9047 52.0026 48.716 52.0807 48.5193 52.0807C48.3225 52.0807 48.1338 52.0026 47.9947 51.8634C47.8556 51.7243 47.7774 51.5356 47.7774 51.3389C47.7763 51.2415 47.7948 51.1449 47.8318 51.0548C47.8687 50.9647 47.9235 50.883 47.9927 50.8145C48.0619 50.746 48.1442 50.6921 48.2346 50.6561C48.3251 50.62 48.4219 50.6025 48.5193 50.6047ZM48.5193 51.8512C48.5842 51.8495 48.6481 51.8347 48.7073 51.8079C48.7664 51.781 48.8196 51.7426 48.8636 51.6948C48.9076 51.647 48.9416 51.5909 48.9636 51.5298C48.9855 51.4686 48.995 51.4037 48.9914 51.3389C48.9972 51.2732 48.9892 51.2071 48.968 51.1447C48.9468 51.0823 48.9129 51.0249 48.8683 50.9763C48.8238 50.9277 48.7697 50.8889 48.7093 50.8624C48.649 50.8359 48.5838 50.8222 48.5179 50.8222C48.452 50.8222 48.3868 50.8359 48.3265 50.8624C48.2661 50.8889 48.212 50.9277 48.1675 50.9763C48.1229 51.0249 48.089 51.0823 48.0678 51.1447C48.0466 51.2071 48.0386 51.2732 48.0444 51.3389C48.0407 51.404 48.0502 51.4691 48.0723 51.5305C48.0944 51.5918 48.1287 51.6481 48.173 51.6959C48.2173 51.7437 48.2708 51.7821 48.3303 51.8088C48.3898 51.8355 48.4541 51.8499 48.5193 51.8512Z",
    fill: "url(#paint13_linear_15622_161551)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.707 50.6297H49.9767V51.5411C49.9741 51.5825 49.9805 51.624 49.9957 51.6627C50.0108 51.7013 50.0343 51.7362 50.0644 51.7647C50.0946 51.7933 50.1306 51.8149 50.17 51.828C50.2094 51.8411 50.2512 51.8454 50.2924 51.8405C50.3332 51.844 50.3743 51.8388 50.413 51.8252C50.4516 51.8115 50.4869 51.7898 50.5165 51.7615C50.5461 51.7332 50.5694 51.6989 50.5847 51.6609C50.6 51.6229 50.6071 51.582 50.6054 51.5411V50.6211H50.8751V51.5411C50.865 51.6877 50.7997 51.8251 50.6923 51.9254C50.5849 52.0257 50.4434 52.0815 50.2965 52.0815C50.1495 52.0815 50.008 52.0257 49.9006 51.9254C49.7932 51.8251 49.7279 51.6877 49.7179 51.5411L49.707 50.6297Z",
    fill: "url(#paint14_linear_15622_161551)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4102 50.6295H51.8747C51.9721 50.6219 52.0708 50.6354 52.1633 50.6697C52.2349 50.7072 52.2949 50.7635 52.3368 50.8327C52.3786 50.9019 52.4008 50.9812 52.4008 51.062C52.4008 51.1429 52.3786 51.2222 52.3368 51.2913C52.2949 51.3605 52.2349 51.4169 52.1633 51.4544C52.1827 51.4756 52.1994 51.4995 52.2115 51.5247L52.5083 52.0645H52.217L51.931 51.5247H51.6803V52.0645H51.4102V50.6295ZM51.9067 51.3037C51.9372 51.3066 51.9679 51.3027 51.9967 51.2923C52.0255 51.2819 52.0517 51.2653 52.0733 51.2436C52.0949 51.2219 52.1115 51.1958 52.1218 51.1669C52.1322 51.1381 52.136 51.1074 52.1331 51.0769C52.1331 50.9393 52.074 50.8559 51.8634 50.8559H51.6663V51.3037H51.9067Z",
    fill: "url(#paint15_linear_15622_161551)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5737 50.6045C53.7707 50.5946 53.9633 50.6604 54.1135 50.788L53.9841 50.982C53.8762 50.8947 53.7421 50.8462 53.6034 50.8444C53.5376 50.8405 53.4716 50.8505 53.4099 50.874C53.3483 50.8974 53.2923 50.9336 53.2456 50.9803C53.199 51.027 53.1628 51.083 53.1394 51.1447C53.1161 51.2064 53.106 51.2724 53.1101 51.3382C53.1053 51.404 53.1141 51.4701 53.1361 51.5322C53.1581 51.5944 53.1927 51.6513 53.2378 51.6995C53.2829 51.7476 53.3374 51.7859 53.398 51.8119C53.4586 51.8379 53.524 51.851 53.5899 51.8506C53.7252 51.8483 53.8537 51.7951 53.9516 51.7022V51.5407H53.7306V51.3166H54.1861V52.0801H53.9489V52.0098V51.9507C53.8348 52.0525 53.6864 52.1073 53.5335 52.104C53.4377 52.1038 53.3429 52.0841 53.2549 52.0461C53.167 52.0081 53.0876 51.9526 53.0217 51.883C52.9559 51.8134 52.9048 51.7312 52.8717 51.6412C52.8386 51.5513 52.8241 51.4556 52.8291 51.3599C52.8246 51.2604 52.8407 51.1611 52.8763 51.0681C52.912 50.9751 52.9665 50.8905 53.0364 50.8196C53.1063 50.7487 53.1901 50.693 53.2826 50.6559C53.375 50.6189 53.4741 50.6014 53.5737 50.6045Z",
    fill: "url(#paint16_linear_15622_161551)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15622_161551",
    x1: 49.5354,
    y1: 52.0127,
    x2: 35.05,
    y2: 36.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FABE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FBCB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15622_161551",
    x1: 50.3584,
    y1: 29.987,
    x2: 43.4318,
    y2: 46.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15622_161551",
    x1: 3467.19,
    y1: 2068.64,
    x2: 1889.44,
    y2: 2171.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15622_161551",
    x1: 37.5999,
    y1: 46.3172,
    x2: 56.901,
    y2: 46.3172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15622_161551",
    x1: 311.322,
    y1: 489.149,
    x2: 614.19,
    y2: 489.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15622_161551",
    x1: 264.005,
    y1: 487.49,
    x2: 508.203,
    y2: 487.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15622_161551",
    x1: 301.236,
    y1: 474.767,
    x2: 583.226,
    y2: 474.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15622_161551",
    x1: 95.0442,
    y1: 217.972,
    x2: 158.738,
    y2: 217.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15622_161551",
    x1: 113.916,
    y1: 219.063,
    x2: 197.501,
    y2: 219.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15622_161551",
    x1: 118.207,
    y1: 217.972,
    x2: 204.869,
    y2: 217.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15622_161551",
    x1: 99.6526,
    y1: 217.972,
    x2: 163.539,
    y2: 217.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15622_161551",
    x1: 139.798,
    y1: 217.972,
    x2: 247.498,
    y2: 217.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15622_161551",
    x1: 110.894,
    y1: 215.794,
    x2: 183.696,
    y2: 215.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15622_161551",
    x1: 141.859,
    y1: 220.768,
    x2: 248.02,
    y2: 220.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15622_161551",
    x1: 123.783,
    y1: 219.063,
    x2: 207.346,
    y2: 219.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15622_161551",
    x1: 121.038,
    y1: 216.331,
    x2: 199.583,
    y2: 216.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15622_161551",
    x1: 138.917,
    y1: 223.668,
    x2: 236.086,
    y2: 223.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15622_161551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(21 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalPostLux);
export default __webpack_public_path__ + "static/media/logoModalPostLux.014edc96084363d688eac48d70c6d00c.svg";
export { ForwardRef as ReactComponent };